import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface ShipTosResultState {
    shipTosResult: ShipToCollectionModel | any;
    selectedBillToId: string;
    selectedShipToId: string;
}

const initialState: ShipTosResultState = {
    shipTosResult: [],
    selectedBillToId: "",
    selectedShipToId: "",
};

export interface BillingShippingParameter {
    billTo: string;
    shipTo: string;
}

const reducer = {
    "Custom/ShipTos/CompleteLoadShipTos": (draft: Draft<ShipTosResultState>, action: { result: any }) => {
        draft.shipTosResult = action.result;
    },
    "Custom/ShipTos/ChangeBillTosShipTosContext": (
        draft: Draft<ShipTosResultState>,
        action: { result: BillingShippingParameter },
    ) => {
        draft.selectedBillToId = action.result.billTo;
        draft.selectedShipToId = action.result.shipTo;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
